export class MainteInfo{
  isMainte: boolean = false
  loginPageText: string = ""
  isDispHeaderText: boolean = false
  isDispLoginText: boolean = false
  headerText: string = ""
  isStudentMainte: boolean = false
  studentLoginPageText: string = ""

  constructor(mainteInfos: any[]){
    if (mainteInfos.length == 0) {
      return;
    }
    var isMainteArry = mainteInfos.filter(x => x.key == "is_mainte");
    var loginPageTextArry = mainteInfos.filter(x => x.key == "mainte_info_login_page_text");
    var isDispHeaderTextArry = mainteInfos.filter(x => x.key == "is_dist_mainte_info_header_text");
    var mainteHeaderTextArry = mainteInfos.filter(x => x.key == "mainte_info_header_text");

    const isStudentSite = window.location.href.indexOf("student_site") != -1;

    this.isMainte = isMainteArry.length > 0 && isMainteArry[0].value == "1";
    this.loginPageText = loginPageTextArry.length > 0 ? loginPageTextArry[0].value : "";
    this.isDispHeaderText = isDispHeaderTextArry.length > 0 && (isDispHeaderTextArry[0].value == "1" || (isDispHeaderTextArry[0].value == "2" && !isStudentSite));
    this.isDispLoginText = isDispHeaderTextArry.length > 0 && isDispHeaderTextArry[0].value == "1";
    this.headerText = mainteHeaderTextArry.length > 0 ? mainteHeaderTextArry[0].value : "";

    var isStudentMainteArry = mainteInfos.filter(x => x.key == "is_student_mainte");
    this.isStudentMainte = isStudentMainteArry.length > 0 && isStudentMainteArry[0].value == "1";
    var studentLoginPageTextArry = mainteInfos.filter(x => x.key == "mainte_info_student_login_page_text");
    this.studentLoginPageText = studentLoginPageTextArry.length > 0 ? studentLoginPageTextArry[0].value : "";
  }
}